module.exports = __webpack_public_path__ + "static/media/comic-move-header.2af99871.png";